import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()((theme) => ({
  listStyle: {
    position: "relative",
    borderRadius: "12px",
    padding: "20px !important",
    marginBottom: 16,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: "#fff",
    border: "1px solid #f0f0f0",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 24px rgba(77, 18, 119, 0.08)",
      borderColor: "#4D127722",
      "& .action-icons": {
        opacity: 1,
        transform: "translateX(0)",
      },
    },
    [theme.breakpoints.down("sm")]: {
      padding: "16px !important",
    },
  },
  accentPersonal: {
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "4px",
      backgroundColor: "#1877F2",
      borderRadius: "12px 0 0 12px",
    },
  },
  accentGeneric: {
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "4px",
      backgroundColor: "#FF5A5F",
      borderRadius: "12px 0 0 12px",
    },
  },
  longTextStyle: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#2d3436",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  shortcutTextStyle: {
    fontWeight: 700,
    fontSize: "13px",
    color: "#4D1277",
    backgroundColor: "#4D127708",
    border: "1px dashed #4D127744",
    borderRadius: "6px",
    height: "28px",
    "& .MuiChip-label": {
      padding: "0 10px",
    },
  },
  iconBox: {
    position: "absolute",
    top: 15,
    right: 15,
    display: "flex",
    gap: "8px",
    opacity: 0,
    transform: "translateX(10px)",
    transition: "all 0.2s ease-in-out",
    backgroundColor: "rgba(255,255,255,0.9)",
    padding: "4px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    [theme.breakpoints.down("sm")]: {
      opacity: 1,
      transform: "translateX(0)",
      position: "relative",
      top: "auto",
      right: "auto",
      marginTop: "10px",
      justifyContent: "flex-end",
      backgroundColor: "transparent",
      boxShadow: "none",
      padding: 0,
    },
  },
  box: {
    display: "flex",
    flexDirection: "column",
  },
  typograhy: {
    width: "100%",
    fontWeight: "400",
    fontFamily: "poppins",
    fontSize: "14px",
    lineHeight: "21px",
    color: "#272525",
  },
  labelTypograhy: {
    width: "100%",
    height: "18px",
    marginTop: "8px",
    fontFamily: "poppins",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#838383",
  },
  span: {
    background: "#F5F5F5",
    borderRadius: "2px",
    padding: "2px 3px",
  },
  icon: {
    height: "24px",
    width: "24px",
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
}));

export default useStyle;
